import moment from 'moment-timezone';
export const decitraitResourceToOptions = (r) => (r || []).map((x) => ({ value: x.id, label: x.name }));
export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
/**
 * count days number between today and futur date
 */
export const countDaysFromToday = ({ date, shouldRound = true }) => {
    let result;
    if (date !== undefined) {
        const { futureDate, timezone } = date;
        const today = moment().tz(timezone).startOf('day');
        result = moment.duration(futureDate.diff(today)).asDays();
        if (shouldRound) {
            result = Math.floor(result);
        }
    }
    return result;
};
/**
 * return theme color based on next threat days count
 */
export const colorFromDaysToNextThreat = (theme, daysToNextThreat) => {
    let result = theme.colors.grayscale.black;
    if (daysToNextThreat !== undefined) {
        if (daysToNextThreat < 3) {
            result = theme.colors.feedback.error['500'];
        }
        else if (daysToNextThreat < 5) {
            result = theme.colors.feedback.warning['500'];
        }
    }
    return result;
};
